import React from "react";
import PropTypes from "prop-types";

import LineItem from "./LineItem";

const MiniBag = ({ items }) => (
  <ul>{items.map((item, i) => <LineItem key={i} {...item} />)}</ul>
);

MiniBag.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      itemType: PropTypes.oneOf(["Product", "Voucher", "Subscription"]),
      images: PropTypes.arrayOf(
        PropTypes.shape({
          size: PropTypes.string,
          url: PropTypes.string
        })
      ),
      name: PropTypes.string,
      colour: PropTypes.string,
      size: PropTypes.string,
      quantity: PropTypes.number
    })
  )
};

MiniBag.defaultProps = {
  items: []
};

export default MiniBag;



// WEBPACK FOOTER //
// ./template/components/MiniBag/MiniBag.js